import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { omit, pick } from 'util/objectMethods';

export default (...queryParamKeys) =>
  WrappedComponent => {
    @withRouter
    class WithRouterQueryParams extends Component {
      static propTypes = {
        location: PropTypes.object,
      };

      render() {
        const { location, ...props } = omit(this.props, ['match', 'history']);
        const queryProps = pick(
          queryString.parse(location.search),
          queryParamKeys
        );

        return <WrappedComponent {...props} {...queryProps} />;
      }
    }

    return WithRouterQueryParams;
  };
